import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-warning-icon',
  standalone: true,
  templateUrl: './warning-icon.component.html',
})
export class WarningIconComponent {
  @Input() width: string = '226';
  @Input() height: string = '234';
}
